import { FC, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Foowear_image_1 from "../../assets/Foowear_image_1.svg";
import { findBrandByDomain } from "../../configs/configLoader";
import { activeStylesContinue } from "../../configs";
import { hoverStylesContinue } from "../../configs/stylesLoader";
import { ArrowForward as ChevronRight } from "@mui/icons-material";
import { capitalizeFirstLetter } from "../../utils";
import MeasuredBy from "../molecules/MeasuredBy";

import "./index.css";

interface IPropsStepIntroInfo {
  step: any;
  nextStep: () => void;
  descriptionStyles: {
    color: string;
    fontSize: React.CSSProperties["fontSize"];
    fontWeight: number;
    textAlign: React.CSSProperties["textAlign"];
    textTransform: React.CSSProperties["textTransform"];
    justifyContent: React.CSSProperties["justifyContent"];
    fontFamily: string;
    lineHeight: string;
    margin: string;
  };
}

const StepIntroInfo: FC<IPropsStepIntroInfo> = ({
  step,
  nextStep,
  descriptionStyles,
}) => {
  const { t } = useTranslation("components/device_select");

  const [hovered, setHovered] = useState(false);

  const brandDefined = findBrandByDomain();

  const isIntersport = brandDefined?.name === "Intersport";
  const isBlackstore = brandDefined?.name === "Blackstore";
  const isCustomBrands = isIntersport || isBlackstore;

  const mergedButtonStyles: React.CSSProperties = {
    ...(isCustomBrands ? activeStylesContinue : {}),
    ...(isIntersport && hovered ? hoverStylesContinue : {}),
    textTransform:
      descriptionStyles.textTransform as React.CSSProperties["textTransform"],
    marginBottom: "10px",
    position: "relative",
    padding: "16px",
    height: "auto",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "visible",
  };

  const arrowContainerStyle: React.CSSProperties = {
    display: "inline-block",
    width: hovered ? 16 : 0,
    overflow: "hidden",
    verticalAlign: "middle",
    transition: "width 160ms ease",
  };

  const iconStyle: React.CSSProperties = {
    width: 16,
    height: 16,
    opacity: hovered ? 1 : 0,
    transform: hovered ? "translateX(0)" : "translateX(-6px)",
    transition: "opacity 160ms ease, transform 160ms ease",
    display: "inline-block",
    verticalAlign: "middle",
    pointerEvents: "none",
  };

  return (
    <>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        <span className="description" style={descriptionStyles}>
          {descriptionStyles.textTransform === "capitalize"
            ? capitalizeFirstLetter(t("intro_info.text"))
            : t("intro_info.text")}
        </span>

        <Box className="info-container">
          <img src={Foowear_image_1} alt="Foowear_image_1" />
        </Box>

        <Box
          className="info-text-container"
          style={{
            display: "flex",
            padding: "0 15px",
          }}
        >
          <Box
            className="info-text-gap-container"
            style={{
              minWidth: "136px",
            }}
          >
            <span className="info-text-container-circle">1</span>
            <span className="info-text-container-text-head">
              {t("intro_info.first_item")}
            </span>
          </Box>

          <div className="divider" />

          <Box
            className="info-text-gap-container"
            style={{
              minWidth: "136px",
            }}
          >
            <span className="info-text-container-circle">2</span>
            <span className="info-text-container-text-head">
              {t("intro_info.second_item")}
            </span>
          </Box>
        </Box>

        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "30px",
          }}
        >
          <span
            style={{
              width: "100%",
              height: "4px",
              background: "#2E2E2E",
              borderRadius: "7px",
            }}
          />
          <span
            style={{
              width: "100%",
              height: "4px",
              background: "#D9D9D9",
              borderRadius: "7px",
            }}
          />
        </Box>

        <button
          type="button"
          className="continue-button"
          onClick={() => {
            nextStep();
          }}
          style={mergedButtonStyles}
          onMouseEnter={() => {
            setHovered(true);
          }}
          onMouseLeave={() => {
            setHovered(false);
          }}
        >
          <div style={{ display: "inline-flex", alignItems: "center", gap: 0 }}>
            {t("intro_info.continue")}

            {isIntersport && (
              <span style={arrowContainerStyle} aria-hidden>
                <ChevronRight style={iconStyle} />
              </span>
            )}
          </div>
        </button>
      </Box>
      <MeasuredBy step={step} />
    </>
  );
};

export default StepIntroInfo;
